import { OverviewCardDefinitions, ChartOverviewDefinitions } from "../definitions";
import { formatNumber } from "./formatting/numbers";
export function getOverviewCards(chartTypeDefinition, overviewData, isLoading) {
    const selectedCardKeys = OverviewCardDefinitions[chartTypeDefinition.key] || OverviewCardDefinitions.default;
    if (!selectedCardKeys) {
        return [];
    }
    if (isLoading || !overviewData) {
        return selectedCardKeys.map((key)=>{
            const definition = ChartOverviewDefinitions.find((def)=>def.key === key);
            return {
                key: definition?.key || key,
                name: definition?.name || key,
                description: definition?.description || "",
                valueType: definition?.valueType || "number",
                value: "-"
            };
        });
    }
    return selectedCardKeys.map((key)=>{
        const definition = ChartOverviewDefinitions.find((def)=>def.key === key);
        const value = overviewData[key];
        if (definition && value !== undefined) {
            return {
                ...definition,
                value: formatNumber(value, 2, definition.valueType)
            };
        }
        return {
            key: definition?.key || key,
            name: definition?.name || key,
            description: definition?.description || "",
            valueType: definition?.valueType || "number",
            value: "-"
        };
    });
}
